export const CountryConstant = {
    SOUTH_AFRICA: '494f423a-f256-41d3-992d-6306199dfe5a'
}